exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_toggleLabel__GmtPj {\n  margin: 0 !important;\n  padding: 0 10px;\n  \n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n\n  color: var(--f7-theme-color) !important;\n  text-align: right !important;\n  font-size: x-small !important;\n}\n\n.styles_toggle__39odk {\n  margin-left: 5px;\n}\n\n.styles_toggleLabel__GmtPj i {\n  padding: 0 0.5rem;\n}\n\n.styles_toggleLabel__GmtPj span {\n  color: var(--f7-button-text-color);\n}\n", ""]);

// Exports
exports.locals = {
	"toggleLabel": "styles_toggleLabel__GmtPj",
	"toggle": "styles_toggle__39odk"
};